import React, { useState, useCallback, useEffect } from 'react';
import { IController } from './IController';
import { IUseMenu } from './IUseMenu';

export function useMenu({
    _anchor,
    items,
    _onOpen,
    _onClose,
    _onHoverStart,
    _onHoverStop,
}: IController): IUseMenu {
    const itemsLength = items.length;
    const [anchor, setAnchor] = useState<HTMLElement | null>(null);

    const onOpen: React.MouseEventHandler<HTMLElement> = useCallback(
        (e) => {
            if (!_anchor) {
                const elemet = e.currentTarget;
                setAnchor(elemet);
                if (itemsLength) setAnchor(elemet);
            }
            _onOpen();
        },
        [itemsLength, _onOpen],
    );

    const onClose: React.MouseEventHandler<HTMLElement> = useCallback(() => {
        if (!_anchor) setAnchor(null);
        _onClose();
    }, [_onClose]);

    const onBtnClick: React.MouseEventHandler<HTMLElement> = useCallback(
        (e) => {
            e.stopPropagation();
            if (anchor) onClose(e);
            else onOpen(e);
        },
        [anchor],
    );

    const onItemClick: React.MouseEventHandler<HTMLLIElement> =
        useCallback(() => {
            if (!_anchor) setAnchor(null);
            _onClose();
        }, [_onClose]);

    const onBtnKeyDown: React.KeyboardEventHandler<HTMLElement> = useCallback(
        (e) => {
            const { key } = e;
            if (key === 'Enter') {
                e.stopPropagation();
                e.preventDefault();
                const target = e.target as HTMLElement;
                target.click();
            }
        },
        [],
    );

    useEffect(() => {
        if (_anchor) setAnchor(_anchor);
        else setAnchor(null);
    }, [_anchor]);

    useEffect(() => {
        return () => {
            _onHoverStop && _onHoverStop();
        };
    }, [_onHoverStop]);

    return {
        anchor,
        onOpen,
        onClose,
        onBtnClick,
        onItemClick,
        onBtnKeyDown,
    };
}
